//function to change the button text
function changeText() {
    var link = $("#btn-filter");
    if (link.text() === "Filtre") {
        link.text("Fermer");
    } else {
        link.text("Filtre") ;
    }
}  

$(document).ready(function(){

    //function to set the height of the gallery div if it is less than the inner filter
    function adjustContainerHeight() {
        var $container = $('.gallery-body');
        var $inner = $('#filters');

        if ($inner.outerHeight() > $container.height()) {
          $container.height($inner.outerHeight());
        }
    }

    $('#filter-toggle-button').on('click', function(){
        $('#filters').toggleClass('open');
        $('#filter-toggle-button').toggleClass('actif');
        $('.gallery-overlay').toggleClass('open');
    });
    $('.gallery-overlay').on('click', function(){
        $('.gallery-overlay').toggleClass('open');
        $('#filters').toggleClass('open');
        $('#filter-toggle-button').toggleClass('actif');
        changeText();
    });

    $('.filter-category h4').on('click', function() {
        $(this).toggleClass('collapsed');
        $(this).next('.filter-options').slideToggle();
        setTimeout(function() {
            adjustContainerHeight();
        }, 300); // The time must match the duration of the transition

    });

    function filterProducts() {
        var selectedFilters = {};

        // Collect selected filters
        $('#filters input[type="radio"]').each(function() {
            var category = $(this).data('category');
            if (this.checked) {
                if (!selectedFilters[category]) {
                    selectedFilters[category] = [];
                }
                selectedFilters[category].push($(this).val());
            }
        });

        $('#product-gallery .product').each(function() {
            var showProduct = true;
            var productClasses = $(this).attr('class').split(' ');

            // Check if the product meets the selected filters
            for (var category in selectedFilters) {
                if (!selectedFilters[category].includes('all') && !productClasses.some(function(cls) {
                    return selectedFilters[category].includes(cls);
                })) {
                    showProduct = false;
                    break;
                }            
            }

            if (showProduct) {
                $(this).removeClass('hidden').removeClass('invisible');//.show();
            } else {
                $(this).addClass('hidden');//.hide();
            }
        });
        setTimeout(function() {
            $('#product-gallery .product.hidden').each(function() {
                $(this).addClass('invisible');
            });
            adjustContainerHeight();
        }, 200); // The time must match the duration of the transition
    }

    $('#filters input[type="radio"]').on('change', filterProducts);

    $('#search-input').on('keyup', function(){
        var searchText = $(this).val().toLowerCase();
        $('#product-gallery .product').each(function() {
            var productTitle = $(this).find('h5').text().toLowerCase();
            if (productTitle.includes(searchText)) {
                $(this).removeClass('hidden').removeClass('invisible');//.show();
            } else {
                $(this).addClass('hidden');//.hide();
            }
        });
        setTimeout(function() {
            $('#product-gallery .product.hidden').each(function() {
                $(this).addClass('invisible');
            });
            adjustContainerHeight();
        }, 200); 
    });
});